export function registerPwa() {
  if (!('serviceWorker' in navigator) || !window.isSecureContext) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(async (registration) => {
      await navigator.serviceWorker.ready;
      const urls = [
        '/',
        '/manifest.webmanifest',
        '/leadflow-mark.svg',
        ...performance.getEntriesByType('resource').map((entry) => entry.name),
      ];
      const sendCacheList = () => registration.active?.postMessage({ type: 'CACHE_URLS', urls });
      if (navigator.serviceWorker.controller) sendCacheList();
      else navigator.serviceWorker.addEventListener('controllerchange', sendCacheList, { once: true });
    }).catch(() => {
      // PWA 缓存失败不影响正常的在线名片采集流程。
    });
  });
}
